import { render, staticRenderFns } from "./GoodList.vue?vue&type=template&id=c4751b8a&"
import script from "./GoodList.vue?vue&type=script&lang=js&"
export * from "./GoodList.vue?vue&type=script&lang=js&"
import style0 from "./GoodList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports